import { createGlobalStyle } from "styled-components"

import { Col } from "../components/Grid"
import { media, mixins } from "./globalTheme"
import xmasHouses from "../images/illustrations/xmas/houses.svg"

import {
  ButtonStyles,
  ButtonStylesLarge,
  ButtonStylesPrimary,
} from "../components/Button"
const GlobalStyle = createGlobalStyle`

  * {
    box-sizing: border-box;
  }

  body {
    background: ${({ theme }) => theme.pageBackground};
    color: ${({ theme }) => theme.textColor};
    font-family: "Euclid-Circular-B", -apple-system, BlinkMacSystemFont,
      "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-weight: ${({ theme }) => theme.fontWeightNormal};
    font-size: 1rem;
    margin: 0;
    -moz-osx-font-smoothing: grayscale; /* better firefox font rendering */
    -webkit-font-smoothing: antialiased; /* better webkit font rendering */

    &.has--nav-open {
      @media ${media.lgDown} {
        overflow: hidden;
      }
    }
  }

  .site {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .site-content {
    flex-grow: 1;
    /* padding-bottom: 50px; */
  }

  h1,
  .h1,
  h2,
  .h2,
  h3,
  .h3,
  h4,
  .h4,
  h5,
  .h5 {
    font-weight: ${({ theme }) => theme.fontWeightBold};
    margin: 0;
  }

  h1,
  .h1 {
    ${mixins.title1};
  }

  h2,
  .h2 {
    ${mixins.title2};
  }

  h3,
  .h3 {
    ${mixins.title3};
  }

  h4,
  .h4 {
    ${mixins.title4};
  }

  h5,
  .h5 {
    ${mixins.title5};
  }

  p,
  li,
  dl {
    ${mixins.copy};

    ul {
      padding-left: 1.25em;
    }
  }

  p,
  ul,
  ol,
  dl {
    margin-bottom: 1.45em;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .text-small {
    & p,
    & li,
    & dl {
      ${mixins.copySmall};

    }
  }

  small {
    color: ${({ theme }) => theme.brandSecondaryMedium};
    font-size: 12px;
  }

  p {
    & + h1,
    & + .h1,
    & + h2,
    & + .h2,
    & + h3,
    & + .h3,
    & + h4,
    & + .h4,
    & + h5,
    & + .h5 {
      margin-top: 30px;

      @media ${media.tablet} {
        margin-top: 50px;
      }
    }
  }

  .caption {
    font-size: 9px;
    font-weight: ${({ theme }) => theme.fontWeightNormal};
    line-height: 1.33333333;
    letter-spacing: 0.02em;

    @media ${media.tablet} {
      font-size: 12px;
      line-height: 16px;
    }

    @media ${media.tabletLandscapelink} {
      font-size: 16px;
      line-height: 22px;
    }
  }

  a {
    color: ${({ theme }) => theme.brandLinks};
    text-decoration: none;

    &:hover {
      color: ${({ theme }) => theme.brandLinksHover};
      text-decoration: none;
    }
  }

  p a {
    &,
    &:hover {
      text-decoration: underline;
    }
  }

  .btn {
    ${ButtonStyles}

    &.btn-large {
      ${ButtonStylesLarge}
    }

    &.btn-primary {
      ${ButtonStylesPrimary}
    }
  }

  hr {
    border: none;
    border-top: 1px solid ${({ theme }) => theme.brandSecondaryMedium};
    margin: 40px 0;
    padding: 0;
    line-height: 1;
  }

  .sr-only {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important;
  }

  [data-reach-dialog-overlay] {
    z-index: 10;
  }

  [data-reach-dialog-content] {
    max-width: 1000px;
    padding: 0;
    position: relative;
    width: 90vw;
  }

  .table {
    overflow-x: auto;

    table {
      border-collapse: collapse;
      border-top: 2px solid #9d9d9d;
      font-size: 9px;
      font-weight: ${({ theme }) => theme.fontWeightNormal};
      letter-spacing: 0.02em;
      text-align: left;
      line-height: 1.333333333;
      margin: 45px 0 75px;

      @media ${media.sm} {
        font-size: 12px;
      }
    }

    th {
      font-weight: ${({ theme }) => theme.fontWeightNormal};
      text-transform: uppercase;
      vertical-align: top;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    td {
      vertical-align: top;
    }

    th,
    td {
      border-bottom: 2px solid #d5d5d5;
      padding: 3px 5px;
    }

    thead th {
      &:empty {
        border-bottom: none;
        padding: 0;
      }
    }
  }

  .table-simple {
    table {
      border-top: none;
    }

    th,
    td {
      border-bottom: 2px solid ${({ theme }) => theme.brandSecondaryDark};
      text-align: left;
    }

    tbody {
      th,
    td {
      border-bottom: 2px solid ${({ theme }) => theme.brandSecondaryLight};
    }
    }
  }

  .table-large {
    table {
      width: 100%;
    }

    th,
    td {
      padding: 20px 3px;
    }

    th {
      text-transform: none;
      font-weight: ${({ theme }) => theme.fontWeightBold};
    }

    thead th {
      font-size: 16px;
      line-height: 1.5;
    }

    @media ${media.smDown} {
      th,
      td,
      thead th {
        font-size: 7px;
      }
    }
  }

  .table-nomargin {
    table {
      margin: 0;
    }
  }

  .table-scroll {
    @media ${media.mdDown} {
      background: linear-gradient(to right, transparent 95%, rgba(0,0,0,0.05) 100%);
      border-radius: 4px;
      padding-bottom: 10px;
    }
  }

  .table-scroll-lg-down {
    @media ${media.lgDown} {
      background: linear-gradient(to right, transparent 95%, rgba(0,0,0,0.05) 100%);
      border-radius: 4px;
      padding-bottom: 10px;
    }
  }

  .linklist {
    ul {
      border-top: 2px solid ${({ theme }) => theme.borderColor};
      /* font-size: 18px; */
      list-style: none;
      padding: 15px 0 0;
      margin: 10px 0 0;

      ${mixins.title5}

      @media ${media.sm} {
        /* font-size: 24px; */

        margin: 10px 0 0;
      }
    }

    li {
      border-bottom: 2px solid ${({ theme }) => theme.borderColor};
      font-size: inherit !important;
      line-height: 1.25 !important;
      margin: 0 0 15px 0;
      padding: 0 0 15px 20px;
      position: relative;

      &:before {
        content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='12' viewBox='0 0 11 12'%3E%3Cg fill='none' fill-rule='evenodd' stroke='%236432FA' stroke-width='2'%3E%3Cpath d='M4.3993 1.235l4.8484 4.8273-4.8484 4.8274'/%3E%3Cpath stroke-linecap='square' d='M1 6.0623h7'/%3E%3C/g%3E%3C/svg%3E");
        display: inline-block;
        left: 0;
        top: 0;
        position: absolute;

        @media ${media.sm} {
          top: -2px;
        }
      }
    }

    a {
      color: ${({ theme }) => theme.brandPrimaryDark};
      font-weight: ${({ theme }) => theme.fontWeightBold};

      &:hover {
        color: ${({ theme }) => theme.brandLinksHover};
      }
    }
  }

code {
  background: ${({ theme }) => theme.codeBackground};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.codeBorder};
  display: inline-block;
  line-break: anywhere;
  line-height: 1;
  margin: 0 2px;
  padding: 2px 4px;

  p & {
    font-size: 0.9em !important;
  }
}

  .notice {
    border: 2px solid ${({ theme }) => theme.brandSecondaryDark};
    margin: 0 0 40px;
    padding: 20px;
  }

  .purple {
    color: ${({ theme }) => theme.brandPrimaryDark};
  }

  .blue {
    color: ${({ theme }) => theme.brandPrimaryMedium};
  }

  .has--background {
    &-purple {
      background-color: ${({ theme }) => theme.brandPrimaryDark};

      h1, h2, h3, h4, h5, h6, p, li {
        /* override color choices */
        color: ${({ theme }) => theme.brandPrimaryLight};

        a {
          color: ${({ theme }) => theme.brandPrimaryMedium};
        }
      }

      small a {
        color: ${({ theme }) => theme.brandPrimaryLight} !important;
      }
    }

    &-blue {
      background-color: ${({ theme }) => theme.brandPrimaryMedium};

      p, li {
        /* override color choices */
        color: ${({ theme }) => theme.brandSecondaryDark};
      }
    }

    &-grey {
      background-color: ${({ theme }) => theme.brandSecondaryLight};

      p, li {
        /* override color choices */
        color: ${({ theme }) => theme.brandSecondaryDark};
      }
    }

    &-white {
      background-color: ${({ theme }) => theme.brandPrimaryLight};

      p, li {
        /* override color choices */
        color: ${({ theme }) => theme.brandSecondaryDark};
      }
    }
  }

  .text-center {
    text-align: center;
  }

  .text-secondary {
    color: ${({ theme }) => theme.brandSecondaryMedium};

    a {
      font-weight: ${({ theme }) => theme.fontWeightNormal};
    }
  }

  .highlightText {
    background-color: ${({ theme }) => theme.brandPrimaryMedium};
    color: inherit;
  }

  .image--svg {
    height: auto;
    max-width: 100%;
  }

  .wrapped {
    position: relative;
  }

  .wrapped-iframe {
    display: block;
    margin-bottom: 3rem;
    padding-top: 56.25%;

    iframe {
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }

  .wrapped-video {
    display: block;
    margin-bottom: 3rem;
    padding-top: 56.25%;

    video {
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }

  .currency-icons {
    display: flex;
    flex-flow: row wrap;
    list-style: none;
    margin: -18px 0 -10px !important;
    padding: 0;

    li {
      align-items: center;
      color: ${({ theme }) => theme.brandSecondaryMedium};
      display: flex;
      flex-flow: row nowrap;
      font-size: 12px;
      line-height: 18px;
      margin: 0 20px 15px 0;

      @media ${media.tablet} {
        font-size: 16px;
        line-height: 24px;
        margin: 0 30px 10px 0;
      }
    }

    svg {
      display: block;
      height: 24px;
      margin: 0 5px 0 0;
      width: 24px;

      @media ${media.tablet} {
        height: 28px;
        width: 28px;
      }

      @media ${media.tabletLandscapelink} {
        height: 36px;
        width: 36px;
      }
    }
  }

  .checklist {
    ul {
      list-style: none;
      padding: 0;
    }

    li {
      margin-bottom: 20px;
      padding: 0 0 0 38px;
      position: relative;

      @media ${media.xl} {
        margin-bottom: 7px;
        padding: 5px 0 5px 38px;
      }

      &:before {
        content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='23' height='17' viewBox='0 0 26 19'%3E%3Cg fill='%236432FA' fill-rule='evenodd'%3E%3Cpolygon points='22.406 0 6.894 15.115 10.342 18.473 25.854 3.359 25.854 3.358'/%3E%3Cpolygon points='0 8.396 10.342 18.473 13.788 15.114 3.447 5.038'/%3E%3C/g%3E%3C/svg%3E");
        display: inline-block;
        left: 0;
        top: 3px;
        position: absolute;
        height: 17px;
        width: 23px;

        @media ${media.xl} {
          top: 5px;
          /* content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='26' height='19' viewBox='0 0 26 19'%3E%3Cg fill='%236432FA' fill-rule='evenodd'%3E%3Cpolygon points='22.406 0 6.894 15.115 10.342 18.473 25.854 3.359 25.854 3.358'/%3E%3Cpolygon points='0 8.396 10.342 18.473 13.788 15.114 3.447 5.038'/%3E%3C/g%3E%3C/svg%3E");
          top: 7px;
          height: 19px;
          width: 26px; */
        }
        }
      }
  }

  /* Targeting an ID we set in Contentful */
  #xmasHouses {
    background: url(${xmasHouses}) ${({ theme }) =>
  theme.brandPrimaryDark} bottom -1px center / 100% auto no-repeat;
    max-width: 1230px;
    margin: 30px auto;
    padding-bottom: 40px;

    @media ${media.sm} {
      padding-bottom: 60px;
    }

    @media ${media.md} {
      margin: 60px auto;
      padding-bottom: 90px;
    }

    @media ${media.lg} {
      padding-bottom: 120px;
    }

    @media ${media.xl} {
      padding-bottom: 160px;
    }

    ${Col} {
      margin: 0;
      max-width: 100%;
      flex: 0 0 100%;
    }
  }
`

export default GlobalStyle
